<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="日期" name=''>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
        @change="changTime" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <div class="m-b-25">
    <span class="p-r-30">累计积分：{{obtain_point}}</span>
    <span class="p-r-30">消耗积分：{{use_point}}</span>
    <span class="p-r-30">可用积分：{{surplus_point}}</span>
  </div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'></a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { mermberPointList } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    start_time:'',
    end_time:'',
    member_id:''
  };
  export default {
    name: "pointsList",
    components: {},
    props: {
      id:{
        type:Number
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        time:[],
        obtain_point:0,
        surplus_point:0,
        use_point:0
      });
      let columns = [
        {
          title: "积分来源",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "类型",
          dataIndex: "action_text",
          key: "action_text",
        },
        {
          title: "积分数量",
          dataIndex: "point",
          key: "point",
        },
        {
          title: "日期",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await mermberPointList({...values,member_id:props.id}).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            state.obtain_point = res.data.obtain_point;
            state.surplus_point = res.data.surplus_point;
            state.use_point = res.data.use_point;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime
      };
    },
  };
</script>